import { ReactNode } from 'react';
import { css, cx } from '@linaria/atomic';
import { onlyText } from 'react-children-utilities';
import { theme } from '@frontend/theme';
import { Text } from '../../../text/text.component';

const subtitleBaseStyle = css`
  margin-top: ${theme.spacing(0.5)};
  margin-right: ${theme.spacing(0)};
  margin-bottom: ${theme.spacing(0.5)};
  margin-left: ${theme.spacing(0)};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow-x: hidden;
  overflow-y: hidden;
  text-overflow: ellipsis;
`;

const subtitleStyles = {
  compact: css`
    font-size: ${theme.fontSize(12)};
    -webkit-line-clamp: 1;
  `,
  normal: css`
    font-size: ${theme.fontSize(14)};
    -webkit-line-clamp: 2;
  `,
};

export const ListRowSubtitle = ({
  children,
  as = Text,
  isCompactMode,
  className,
  ...rest
}: {
  children: ReactNode;
  as?: React.ElementType;
  isCompactMode?: boolean;
  className?: string;
}) => {
  const Component = as;

  return (
    <Component
      className={cx(
        subtitleBaseStyle,
        isCompactMode ? subtitleStyles.compact : subtitleStyles.normal,
        'content-column-subtitle',
        className
      )}
      title={onlyText(children as React.ReactNode)}
      {...rest}
    >
      {children}
    </Component>
  );
};
